import { DateRangePicker } from '../datetimepicker'

$(function() {
  $('.remove-prometheus').on('click', function(){
    let target = $('.prometheus_destroy[value=false]:last').parent('.prometheus-fields')

    target.hide();
    target.find('.prometheus_destroy').val('1')
  })

  $('#prometheus_form').on('cocoon:after-insert', function() {
    DateRangePicker();
    updatePrometheusTypes();
  })

  // PrometheusⅢプルダウン用 初期化
  updatePrometheusTypes();

  // PrometheusⅢプルダウン用 履歴追加時
  $('.add-prometheus').on('click', function() {
    updatePrometheusTypes();
  });

  // PrometheusⅢプルダウン用 プルダウンメニュー変更時
  $(document).on('change', "[id*=prometheus_type]", function() {
    updatePrometheusTypes();
  });

  $('.rank-select2').select2();
});

function updatePrometheusTypes() {
  // 動的に増加する要素のために毎回取得し直す
  var p_types = $("[id*=prometheus_type]");
  var histories_num = p_types.length;

  // 全プルダウンメニューに対して処理を行う
  for (var i = 0; i < histories_num; i++) {
    selectPrometheusType(i);
  }
}

//PrometheusⅢの場合、PrometheusⅠ・Ⅱの選択肢を非表示にする
function selectPrometheusType(num) {
  var select_p_type = $("[id*=prometheus_type]")[num];
  var select_p_large_category = $("[id*=prometheus_large_category]")[num];

  // span初期化
  var spans = $('select[name="' + select_p_large_category.name + '"] span');
  for (var i = 0; i < spans.length; i++) {
    spans.eq(i).children().unwrap();
  }

  var selected_p_type_value = select_p_type.options[select_p_type.options.selectedIndex].value

  // select内のoptionに対してhideをかけると、safariで非表示にならないためspanで囲って非表示にする
  if (selected_p_type_value == 'prometheus1' || selected_p_type_value == 'prometheus2') {
    $('select[name="' + select_p_large_category.name + '"] option[value="p3"]').wrap('<span style="display: none;">');
  } else if (selected_p_type_value == 'prometheus3') {
    // 今後PrometheusⅢ以外の商品が追加される想定のため、option要素はvalueを直接指定する
    $('select[name="' + select_p_large_category.name + '"] option[value="course1"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="course2"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="course3"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="course4"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="option1"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="option2"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="option3"]').wrap('<span style="display: none;">');
    $('select[name="' + select_p_large_category.name + '"] option[value="option4"]').wrap('<span style="display: none;">');
  }
}
